const LookupsTypes = {
  GET_TAX_TYPES_TYPES: 'LOOKUPS_TYPES.GET_TAX_TYPES_TYPES',
  SET_TAX_TYPES_TYPES: 'LOOKUPS_TYPES.SET_TAX_TYPES_TYPES',

  GET_PRICING_BASIS: 'LOOKUPS_TYPES.GET_PRICING_BASIS',
  SET_PRICING_BASIS: 'LOOKUPS_TYPES.SET_PRICING_BASIS',

  GET_PRICING_TYPES: 'LOOKUPS_TYPES.GET_PRICING_TYPES',
  SET_PRICING_TYPES: 'LOOKUPS_TYPES.SET_PRICING_TYPES',

  GET_MEASUREMENT_UNIT_TYPES: 'LOOKUPS_TYPES.GET_MEASUREMENT_UNIT_TYPES',
  SET_MEASUREMENT_UNIT_TYPES: 'LOOKUPS_TYPES.SET_MEASUREMENT_UNIT_TYPES',

  GET_LINER_CODES: 'LOOKUPS_TYPES.GET_LINER_CODES',
  SET_LINER_CODES: 'LOOKUPS_TYPES.SET_LINER_CODES',

  GET_PAYMENT_TYPES: 'LOOKUPS_TYPES.GET_PAYMENT_TYPES',
  SET_PAYMENT_TYPES: 'LOOKUPS_TYPES.SET_PAYMENT_TYPES',

  GET_VENDOR_FIELDS_VISIBILITY: 'LOOKUPS_TYPES.GET_VENDOR_FIELDS_VISIBILITY',
  SET_VENDOR_FIELDS_VISIBILITY: 'LOOKUPS_TYPES.SET_VENDOR_FIELDS_VISIBILITY',
};

export default LookupsTypes;
